import React, { Fragment, useContext, useEffect, useState } from 'react';
import PageBodyWrapper from "root/PageBodyWrapper";
import TableUnsubmittedSurveys from "root/Tables/TableUnsubmittedSurveys";
import { getDataFromResponse, toCapitalised } from "root/DataFunctions/BaseDataFns";
import { getProviderCompletionDetails } from "root/DataFunctions/SchoolDataFns";
import GlobalContext from "root/Contexts/GlobalContext";
import { useParams } from "react-router-dom";

const AdminSubmittedReport = (props) =>
{
    const [data, setData] = useState({loading: true, data: []});

    const sessionContext = useContext( GlobalContext ) ;

    let {submitted_status} = useParams();

    const survey_type = sessionContext.getCurrentSurveyType() ;

    useEffect(() => {
        getData();
    }, []);

    const getData = () =>
    {
        getProviderCompletionDetails( 'current', survey_type, submitted_status, (response) =>
        {
            const returnData = getDataFromResponse(response) ;

            setData({loading: false, data: returnData})
        })
    }

    return (
        <Fragment>
            <PageBodyWrapper title={toCapitalised(submitted_status) + ' Surveys'} backButton={true}>
                <div className='manage-grid-rows'>
                    <div className='dash-style' style={{padding: '15px'}}>
                        <TableUnsubmittedSurveys data={data} survey_type={survey_type}/>
                    </div>
                </div>
            </PageBodyWrapper>
        </Fragment>
    )
}

export default AdminSubmittedReport;